<template>
  <div>
    <span v-if="rowId !== 0 && !isDesktop" class="popover-shadow"
          :class="{'Pe' : isRemovePe}"></span>
    <div class="new__popover" v-if="rowId !== 0"
         :class="{'popover-mobile': !isDesktop, 'Pe' : isRemovePe,
         'popover-noFixture': !slopeFromState.fixtureCalculation.need }"
         :style="{transform: (isDesktop)
            ? (mouseLeft > (windowWidth / 2))
             ? `translate3d(${mouseLeft - 251}px, ${mouseTop + 20}px, ${0}px)`
             : `translate3d(${mouseLeft + 15}px, ${mouseTop + 20}px, ${0}px)`
            : `translate3d(${(windowWidth / 2) - 118}px, ${40}vh, ${0}px)`}">
      <!--:style="{top: `${mouseTop + 20}px`,
      right: (mouseLeft > (windowWidth / 2)) ? `${windowWidth - mouseLeft}px` : `unset`,
      left: (mouseLeft < (windowWidth / 2)) ? `${mouseLeft + 15}px` : `unset`
      }"-->
      <div class="new__popover-close" v-if="!isDesktop">
        <img src="@/assets/img/close-red.svg" alt="close">
      </div>
      <div class="popover__row-info">
        <div class="text">
            <span class="text__name">
              Row {{ rowId }}
            </span>
          <span class="text__info" v-if="masonryType === 'ABC'">
            <span v-if="layersCount > 1">
              {{ layersCount }}</span><span
              v-if="(((rowId)) % 2 === 0)">B</span>
            <span v-else>A</span>
            <span v-if="(Math.floor(((rowId) + 1) / 2) - 1) > 0">
              + <span v-if="Math.floor(((((rowId) + 1) / 2) - 1) * layersCount) > 1">
              {{(Math.floor(((rowId) + 1) / 2) - 1) * layersCount}}</span>C
            </span>
          </span>
          <span class="text__info" v-else-if="masonryType === 'JKD'">
            <span v-if="layersCount > 1">
              {{ layersCount }}</span><span
            v-if="(((rowId)) % 2 === 0)">K</span>
            <span v-else>J</span>
            <span v-if="(Math.floor(((rowId) + 1) / 2) - 1) > 0">
              + <span v-if="Math.floor(((((rowId) + 1) / 2) - 1) * layersCount) > 1">
              {{(Math.floor(((rowId) + 1) / 2) - 1) * layersCount}}</span>D
            </span>
          </span>
          <span class="text__info" v-else>
            <span v-if="layersCount > 1">
              {{ layersCount }}</span><span
            v-if="masonryType === 'JD'">J</span>
            <span v-else>M</span>
            <span v-if="(rowId - 1) > 0">
              + <span>
              <span v-if="((rowId - 1) * layersCount) > 1">
                {{ (rowId - 1) * layersCount}}</span></span>D
            </span>
          </span>
        </div>
        <div class="img" v-if="slopeFromState.fixtureCalculation.need">
          <span class="img__text" v-if="plateWidth < plateHeight">{{ fastenerFirst }}<br>mm</span>
          <span class="img__text" v-else>{{ fastenerSecond }}<br>mm</span>
          <img v-if="isPir && (plateWidth > plateHeight)"
               src="@/assets/img/pir-brick-horizontal.svg" alt="brick">
          <img v-else-if="isPir && (plateHeight > plateWidth)"
               src="@/assets/img/pir-brick-vertical.svg" alt="brick">
          <img v-else-if="!isPir && (plateWidth > plateHeight)"
               src="@/assets/img/brick-horizontal.svg" alt="brick">
          <img v-else-if="!isPir && (plateHeight > plateWidth)"
               src="@/assets/img/brick-vertical.svg" alt="brick">
          <img v-else src="@/assets/img/brick-rect.svg" alt="brick">
          <span class="img__text">{{ fastenerFirst }}<br>mm</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import device from 'current-device';

export default {
  props: {
    rowId: Number,
    layersCount: Number,
    windowWidth: Number,
    mouseLeft: Number,
    mouseTop: Number,
    plateHeight: Number,
    plateWidth: Number,
    materialAngle: Number,
    fixtureCalculationThickness: Number,
    backEndRowsCount: Number,
    masonryType: String,
    hKr: Number,
    qKr: Number,
    y1: Number,
    y2: Number,
    isRemovePe: Boolean,
  },
  data() {
    return {
      isDesktop: '',
      // d1: this.y1 * (this.y2 - this.y1) / this.plateWidth,
    };
  },
  watch: {
    rowId() {
      if (!device.desktop()) {
        if (this.rowId !== 0) {
          this.$root.offBodyScroll();
        } else {
          this.$root.onBodyScroll();
        }
      }
    },
  },
  methods: {
    myRound(val) {
      return Math.round(val / 10) * 10;
    },
  },
  computed: {
    d1() {
      return this.y1 * (this.plateWidth / (this.y2 - this.y1));
    },
    fastenerFirst() {
      return this.myRound(Math.floor(((this.rowId - 1) * this.plateWidth + this.hKr + this.d1)
        * Math.tan(this.layersCount * Math.atan(this.materialAngle / 100))
        + this.thickness));
    },
    fastenerSecond() {
      if (this.rowId < this.backEndRowsCount) {
        return this.myRound(Math.floor(((this.rowId - 1) * this.plateWidth + this.plateWidth
          - this.hKr + this.d1) * Math.tan(this.layersCount * Math.atan(this.materialAngle / 100))
          + this.thickness));
      } return this.maxFastener;
      // return this.myRound((this.slopeFromState.slopeParams[0].width * 1000 - this.hKr + this.d1)
      //   * (Math.tan(this.layersCount * Math.atan(this.materialAngle / 100))
      //   ) + ((this.slopeFromState.fixtureCalculation.need) ? this.thickness : 0));
    },
    isPir() {
      return (this.allMaterials[this.allMaterials.findIndex(p => p.id
        === this.slopeFromState.material)].type) === 'LOGICPIR';
    },
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    thickness() {
      return (this.slopeFromState.fixtureCalculation.need) ? this.fixtureCalculationThickness : 0;
    },
    result() {
      return this.$store.getters.getResult;
    },
    section() {
      return this.result.sections[this.slopeId];
    },
    maxFastener() {
      return Math.max.apply(null, this.section.fasteners_group.map(a => a.thickness));
    },
  },
  mounted() {
    this.isDesktop = device.desktop();
  },
};
</script>

<style lang="sass" scoped>
.new__popover
  &.Pe
    pointer-events: auto
.popover
  &-shadow
    height: 100vh
    width: 100vw
    top: 0
    left: 0
    position: fixed
    background: rgba(0, 0, 0, 0.50)
    pointer-events: none
    z-index: 3
    &.Pe
      pointer-events: auto
    // &:after
      position: fixed
      left: 0
      top: 0
      height: 100vh
      width: 100vw
      background: red
      content: ""
    // box-shadow: 0 0 0.875rem rem(1000) rgba(0, 0, 0, 0.5)
</style>
